import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { take, finalize, Subscription } from 'rxjs';
import { PageSizeService } from '../../services/page-size/page-size.service';
import { FormRelatorioComponent } from '../../shared/modals/form-relatorio/form-relatorio.component';
import { ModalDeleteLotesComponent } from '../../shared/modals/modal-delete-lotes/modal-delete-lotes.component';
import { ModalFiltersComponent } from '../../shared/modals/modal-filters/modal-filters.component';
import { AlertComponent } from '../alert/alert.component';
import { LoadingService } from '../loading/loading.service';
import { ModalComponent } from '../modal/modal.component';
import { AuthService } from '../../services/auth/auth.service';
import { UserService } from '../../services/user/user.service';
import { ProjetosService } from '../../services/projetos/projetos.service';
import { Router } from '@angular/router';
import { ModalHistoricComponent } from '../../shared/modals/modal-historic/modal-historic.component';
import { ModalController } from '@ionic/angular';
import { Status } from '../../shared/interface/status-filter.interface';
import { ToastService } from '../../services/toast/toast.service';
import { AprovarAnaliseComponent } from '../../shared/modals/aprovar-analise/aprovar-analise.component';

@Component({
  selector: 'app-projetos',
  templateUrl: './projetos.component.html',
  styleUrls: ['./projetos.component.scss'],
})
export class ProjetosComponent {
  @ViewChild('informacoesComplementaresModal') informacoesComplementaresModal!: TemplateRef<any>;
 @Input() cnpj: any;
  @Input() buttonInclusaoDisabled: boolean = false;
  @Input() buttonExclusaoDisabled: boolean = false;
  @Input() buttonEdicaoDisabled: boolean = false;
  visualizarDetalhes: boolean = true;
  isSoloConcessionaria: boolean = false;
  screenWidth: number = 0;
  screenHeight: number = 0;
  @Input() contractId: any;
  statusTransition: any;
  idEntidade: any;
  // === ABAS ===
  activeTab = 'Funcional';
  tabs = [
    { label: 'Funcional', value: 'Funcional' },
    { label: 'Executivo', value: 'Executivo' },
  ];

  get activeFrom(): string {
    return this.activeTab === 'Executivo' ? 'listar-projetos-executivo' : 'listar-projetos';
  }

  private readonly colsFuncional = [
    { columnDef: 'contrato', header: 'Contrato', property: 'contrato.contractNumber', customTd: true },
    { columnDef: 'obra', header: 'Código da Obra', property: 'parametroServicoAmpliacao.descricaoServico', customTd: true },
    { columnDef: 'statusAtual', header: 'Status', property: 'statusAtual', customTd: true },
    { columnDef: 'actions', header: 'Ações', custom: true },
  ];

  private readonly colsExecutivo = [
    { columnDef: 'contrato', header: 'Contrato', property: 'contrato.contractNumber', customTd: true },
    { columnDef: 'obra', header: 'Código da Obra', property: 'parametroServicoAmpliacao.descricaoServico', customTd: true },
    { columnDef: 'statusAtual', header: 'Status', property: 'statusAtual', customTd: true },
    { columnDef: 'actions', header: 'Ações', custom: true },
  ];

  get columnConfig() {
    return this.activeTab === 'Executivo' ? this.colsExecutivo : this.colsFuncional;
  }

displayedColumns: string[] = [];

  // === TABELA ===
  sortState = {
    sortProperty: 'criadoEm',
    sortDirection: 'desc',
  };
  filterParametro: string = '';
  arrayStatus: any = [
    { label: 'Em processo de cadastro', property: '', selected: false },
    { label: 'Em análise', property: '', selected: false },
    { label: 'Aguardando revisão', property: '', selected: false },
    { label: 'Não objeção', property: '', selected: false },
    { label: 'Não objeção com ressalvas', property: '', selected: false },
    { label: 'Cancelado', property: '', selected: false },
  ];
  subsctiptions: Subscription[] = [];
  dataSource = new MatTableDataSource<any>();
  pageIndex = 0;
  pageSize = 10;
  totalPages = 1;
  totalElements = 0;
  dataAction: any;
  idRelatorio: any;
  criterios: any = [];
  criteriosLabels!: { [key: string]: string };
  formProjetos!: FormGroup;
  filterData: any;
  filterText: string = '';
  listaStatus: Status[] = [];
  restoreExpandedId: string | null = null;
  statusFilter: any;
  idProjeto: any;
  transicaoId: any;
  statusAtualId: any;
  informacoesComplementares: any;
  anexosImagem: any[] = [];
  anexosDocumento: any[] = [];
  imagemAtual: number = 0;
  // === CONSTRUTOR ===
  constructor(
    private projetosService: ProjetosService,
    private _snackBar: MatSnackBar,
    private loadingService: LoadingService,
    private pageSizeService: PageSizeService,
    public dialog: MatDialog,
    private fb: FormBuilder,
    private authService: AuthService,
    private userService: UserService,
    private router: Router,
    private modalCtrl: ModalController,
    public toastService: ToastService,
  ) {}
  ngOnInit(): void {
    this.displayedColumns = this.columnConfig.map((col) => col.columnDef);
    this.getFilterOptions();
    this.formProjetos = this.fb.group({
      contractNumber: [''],
      codigo: [''],
    });
    this.buildCriteriosLabels();
    this.loadUserInfo();
  }

  onTabChange(tab: string): void {
    this.activeTab = tab;
    this.pageIndex = 0;
    this.getData(this.contractId, 0);
  }
  private buildCriteriosLabels() {
    this.criteriosLabels = {
      contractNumber: 'Contrato',
      codigo: 'Obra',
    };
  }
  loadUserInfo() {
    const userId = this.authService.getUserIdFromToken();
    if (userId) {
      this.userService.getMenuUsuario(userId).subscribe((response: any) => {
        const functionalities = response.profileUser.permissaoPerfis;
        functionalities.forEach((permission: any) => {
          this.checkFunctionality(permission.funcionalidade);
        });

        const tiposEntidade: any[] = response.tiposEntidade || [];
        const isSoloConcessionaria =
          tiposEntidade.length > 0 &&
          tiposEntidade.every((t: any) => t.tipoEnum === 'CNC');
        this.visualizarDetalhes = !isSoloConcessionaria;
        this.isSoloConcessionaria = isSoloConcessionaria;

        if (isSoloConcessionaria) {
          this.arrayStatus = this.arrayStatus.map((s: any) => ({
            ...s,
            selected: s.label === 'Em processo de cadastro' || s.label === 'Aguardando revisão',
          }));
          this.statusFilter = this.arrayStatus.filter((s: any) => s.selected);
          this.getData(this.contractId);
        }
      });
    }
  }
  getFilterOptions() {
    this.projetosService.getFiltrosStatus().pipe(take(1)).subscribe({
      next: (resp: any) => {
        this.listaStatus = resp;
        this.statusFilter = this.listaStatus.filter(item => item.selecionado);
        this.getData(this.contractId);
      },
      error: () => this.getData(this.contractId),
    });
  }

  checkFunctionality(functionality: any) {
    if (functionality.url === '/projetos') {
      this.handleRestrictions(functionality.restricoes);
    }

    if (
      functionality.subFuncionalidades &&
      functionality.subFuncionalidades.length > 0
    ) {
      functionality.subFuncionalidades.forEach((subFunctionality: any) => {
        this.checkFunctionality(subFunctionality);
      });
    }
  }

  handleRestrictions(restrictions: any[]) {
    restrictions.forEach((restriction: { nome: any }) => {
      switch (restriction.nome) {
        case 'Inclusão':
          this.buttonInclusaoDisabled = true;
          break;
        case 'Exclusão':
          this.buttonExclusaoDisabled = true;
          break;
        case 'Edição':
          this.buttonEdicaoDisabled = true;
          break;
      }
    });
  }
  /** Navegar para criação de novo serviço */
  create(): void {
    this.router.navigate([`criar-projeto`]);
  }

  // Requisição da listagem de projetos
  getData(contractId: string, pageIndex: number = 0, keepExpandedId?: string): void {
    this.projetosService
      .getProjetos(
        this.pageSize,
        pageIndex,
        this.sortState.sortDirection,
        this.sortState.sortProperty,
        this.contractId,
        this.filterParametro,
        this.filterData,
        this.statusFilter,
        this.activeTab,
      )
      .pipe(
        take(1),
        finalize(() => this.loadingService.hideLoading()),
      )
      .subscribe({
        next: (res: any) => {
          const { content, pageSize, totalPages, totalElements, pageNumber } =
            res;

          this.dataSource.data = content;
          this.pageSize = pageSize;
          this.totalPages = totalPages;
          this.totalElements = totalElements;
          this.pageIndex = pageNumber;

          if (keepExpandedId) {
            this.restoreExpandedId = null;
            setTimeout(() => { this.restoreExpandedId = keepExpandedId; }, 0);
          }
        },
        error: (erro: any) => this.handleRequestError(erro),
      });
  }
  filterStatusChanged(event: {}) {
    this.statusFilter = event;
    this.getData(this.contractId);
  }
  // === ORDENAÇÃO ===
  onSortChange(sortProperty: string): void {
    if (this.sortState.sortProperty === sortProperty) {
      this.sortState.sortDirection =
        this.sortState.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortState.sortProperty = sortProperty;
      this.sortState.sortDirection = 'asc';
    }

    // Requisição pode ser disparada aqui se necessário
    this.getData(this.contractId, 0);
  }
  // === PAGINAÇÃO ===
  pageChangeEvent(event: PageEvent): void {
    const { pageIndex, pageSize } = event;

    if (this.pageSize !== pageSize) {
      this.pageSize = pageSize;
      this.pageSizeService.setPageSize(pageSize);
      this.getData(this.contractId, 0);
      return;
    }

    if (this.pageIndex !== pageIndex) {
      this.getData(this.contractId, pageIndex);
    }
  }

  // Tratamento centralizado de erros de requisição
  private handleRequestError(erro: any): void {
    if (erro.status !== 500 && erro.status) {
      this.openSnackBar(erro.error.message, 'error');
    } else if (erro.error?.error === 'Unprocessable Entity') {
      this.openSnackBar(erro.error.message, 'warning');
    } else {
      this.openSnackBar(
        'Sistema indisponível. Estamos trabalhando para resolver. Por favor, tente novamente mais tarde.',
        'error',
      );
    }
  }
  // === SNACKBAR DE ALERTA ===
  openSnackBar(description: string, type: string): void {
    const classMap: Record<string, string> = {
      sucess: 'snacbar-sucess',
      warning: 'snacbar-warning',
      error: 'snacbar-error',
    };

    const classSnack = classMap[type] || 'snacbar-default';

    this._snackBar.openFromComponent(AlertComponent, {
      duration: 3000,
      panelClass: [classSnack, 'snackbar-custom'],
      data: { description, type },
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }
  openDeleteDialog(id: number): void {
    const modalTitle: string = 'Excluir';
    const modalContent: string =
      'Você tem certeza que deseja excluir este Projeto?';

    const dialogRef = this.dialog.open(ModalComponent, {
      data: {
        onPerformAction: this.onDeleteModalConfirm.bind(this),
        modalTitle: modalTitle,
        modalContent: modalContent,
        id: id,
      },
    });
  }
  onDeleteModalConfirm(id: any): void {
    this.loadingService.showLoading();

    this.subsctiptions.push(
      this.projetosService
        .deleteProjeto(id)
        .pipe(
          finalize(() => {
            this.loadingService.hideLoading();
          }),
        )
        .subscribe({
          next: (resp: any) => {
            this.openSnackBar('Projeto deletado com sucesso.', 'sucess');
            this.getData(this.contractId);
          },
          error: (err: any) => {
            this.openSnackBar(err.error.message, 'error');
          },
        }),
    );
  }
     redirectToDetailPage(id: number): void {
    this.router.navigate([`detail-projeto/${id}`]);
  }
  redirectToEditPage(id: number): void {
    this.router.navigate([`editar-projeto/${id}`]);
  }


  openInformacoesComplementares(id: number): void {
    this.loadingService.showLoading();
    this.projetosService.getInformacoesComplementaresProjeto(id)
      .pipe(
        take(1),
        finalize(() => this.loadingService.hideLoading())
      )
      .subscribe({
        next: (res: any) => {
          if (!res || Object.keys(res).length === 0) {
            this.toastService.showError('Não existem informações complementares para o projeto informado.');
            return;
          }
          this.informacoesComplementares = res;
          this.anexosImagem = (res.anexos || []).filter((anexo: any) => this.isImagemAnexo(anexo));
          this.anexosDocumento = (res.anexos || []).filter((anexo: any) => !this.isImagemAnexo(anexo));
          this.imagemAtual = 0;
          this.dialog.open(this.informacoesComplementaresModal, {
            width: '980px',
            maxWidth: '95vw',
            panelClass: 'informacoes-complementares-dialog'
          });
        },
        error: (erro: any) => {
          if (erro.status === 404) {
            this.toastService.showError(erro.error?.message || 'Não existem informações complementares para o projeto informado.');
            return;
          }
          this.handleRequestError(erro);
        }
      });
  }
  private isImagemAnexo(anexo: any): boolean {
    return /\.(png|jpg|jpeg|gif|bmp|webp|svg)$/i.test(anexo?.nomeArquivo || '');
  }
  imagemAnterior(): void {
    if (this.imagemAtual > 0) {
      this.imagemAtual--;
    }
  }
  proximaImagem(): void {
    if (this.imagemAtual < this.anexosImagem.length - 1) {
      this.imagemAtual++;
    }
  }
  abrirAnexo(anexo: any): void {
    if (!anexo?.sasURL) {
      this.toastService.showError('Link para download indisponível');
      return;
    }
    window.open(anexo.sasURL, '_blank');
  }
  async openDialogHistoricoProjeto(id: number) {
    const data = {
      type: 'projetos',
      id: id,
      contracId: this.contractId,
      fieldMappings: {
        contrato: 'Contrato',
        parametroServicoAmpliacao: 'Parâmetro de serviço de ampliação',
        tipoProjeto: 'Tipo de projeto',
        tipoInvestimento: 'Tipo de investimento',
        nomeProjeto: 'Nome',
        observacao: 'Observação',
        statusAtual: 'Status',
        dataAfericao: 'Data da aferição',
        arquivos: 'Arquivos',
      },
    };
    const modal = await this.modalCtrl.create({
      component: ModalHistoricComponent,
      componentProps: {
        data: data,
        fieldMappings: data.fieldMappings,
      },
    });

    modal.present();
  }
  onRowExpanded(row: any): void {
    if (this.activeTab === 'Executivo' && !row._disciplinasLoaded) {
      this.projetosService
        .getDisciplinasCadastradasPorIdPaginada(100, 0, 'asc', 'id', row.id)
        .pipe(take(1))
        .subscribe({
          next: (res: any) => {
            row.disciplinas = res.content;
            row._disciplinasLoaded = true;
          },
          error: () => { row.disciplinas = []; },
        });
    }
  }

  onDisciplineAction(event: { action: string; row: any; discipline: any; transicaoId?: string; transicaoNome?: string }): void {
    if (event.action === 'viewInfo') {
      this.openInformacoesComplementares(event.discipline.id);
    } else if (event.action === 'tramitar') {
      this.transitionDisciplineStatusChanged(event);
    } else if (event.action === 'history') {
      this.openDialogHistoricoDisciplina(event.row.id, event.discipline.id);
    }
  }

  transitionDisciplineStatusChanged(event: { row: any; discipline: any; transicaoId?: string; transicaoNome?: string }): void {
    const idProjeto = event.row.id;
    const disciplina = event.discipline;
    const idExterno = disciplina.id;
    const idStatusAtual = disciplina.status?.statusAtual?.id;
    const transicaoNome = event.transicaoNome;
    const isAguardandoRevisao = disciplina.statusAtual === 'Aguardando revisão';
    const cnpj = event.row.contrato?.company?.cnpj;

    if (transicaoNome === 'Enviar para análise' && isAguardandoRevisao) {
      this.openDisciplineAnalyzeDialog(idProjeto, idExterno, idStatusAtual, event.transicaoId!, event.row, cnpj);
      return;
    }

    const payload = { idExterno, idStatusAtual, idTransicao: event.transicaoId };
    const formData = new FormData();
    formData.append('request', new Blob([JSON.stringify(payload)], { type: 'application/json' }));
    this.transitionDisciplineStatus(idProjeto, formData, event.row);
  }

  openDisciplineAnalyzeDialog(idProjeto: string, idExterno: string, idStatusAtual: string, transicaoId: string, row: any, cnpj?: string): void {
    const dialogRef = this.dialog.open(AprovarAnaliseComponent, {
      width: '1550px',
      data: {
        idAnaliseAfericao: idExterno,
        statusAtualId: idStatusAtual,
        transicaoId: transicaoId,
        fromProjetos: true,
        isDisciplina: true,
        cnpj: cnpj,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.transitionDisciplineStatus(idProjeto, result, row);
      }
    });
  }

  transitionDisciplineStatus(idProjeto: string, formData: FormData, row?: any): void {
    this.loadingService.showLoading();

    this.projetosService
      .postTransicaoStatusDisciplina(idProjeto, formData)
      .pipe(
        take(1),
        finalize(() => this.loadingService.hideLoading()),
      )
      .subscribe({
        next: () => {
          this.getData(this.contractId, this.pageIndex, row?.id);
          this.toastService.showSuccess('Mudança de status da disciplina realizada com sucesso');
        },
        error: (erro: any) => {
          if (erro.status !== 500 && erro.status) {
            this.toastService.showError(erro.error.message);
          } else {
            this.toastService.showError();
          }
        },
      });
  }

  async openDialogHistoricoDisciplina(idProjeto: string, idDisciplina: string): Promise<void> {
    const data = {
      type: 'disciplinaProjeto',
      id: idDisciplina,
      projectId: idProjeto,
      fieldMappings: {
        statusAtual: 'Status',
        numRevisao: 'Revisão',
      },
    };
    const modal = await this.modalCtrl.create({
      component: ModalHistoricComponent,
      componentProps: { data, fieldMappings: data.fieldMappings },
    });
    modal.present();
  }

  applyFilter(filterValue: string) {
    this.filterParametro = filterValue;
    this.getData(this.contractId);
  }
  openModalFilters(popover?: any) {
    let props;
    if (this.filterData) {
      props = this.filterData;
    } else {
      props = this.generatePropsFromForm(this.formProjetos);
    }

    const data = {
      type: 'projetos',
      propsProjetos: props,
      idContrato: this.contractId,
    };

    const dialogRef = this.dialog.open(ModalFiltersComponent, {
      panelClass: ['filter-panel'],
      data,
    });

    dialogRef.afterClosed().subscribe({
      next: (data: any) => {
        if (data) {
          // Atualiza os critérios com base nos dados do modal
          this.filterData = data;
          this.criterios = this.getCriterios(data);
          this.getData(this.contractId);
        }
      },
    });
  }

  // Função para gerar o objeto props de forma dinâmica a partir dos valores do formulário
  private generatePropsFromForm(form: FormGroup): any {
    const props: any = {};
    // Itera sobre os controles do FormGroup
    Object.keys(form.controls).forEach((controlName: string) => {
      const control = form.get(controlName);

      // Verifica se o controle tem valor e não é nulo ou vazio
      if (
        control &&
        control.value !== null &&
        control.value !== undefined &&
        control.value !== ''
      ) {
        props[controlName] = control.value;
      }
    });
    return props;
  }

  getCriterios(data: any) {
    const criterios = [];

    // Gera os critérios de forma dinâmica, verificando os valores dos campos
    const props: any = this.generatePropsFromForm(data);

    for (const prop in props) {
      if (
        props[prop] !== null &&
        props[prop] !== undefined &&
        props[prop] !== ''
      ) {
        criterios.push(prop);
      }
    }

    return criterios;
  }
  criterioRemoved(event: any) {
    // Lógica para remover da lista de critérios, se necessário
    this.filterData.patchValue({
      [event.criterio]: null,
    });
    this.criterios = this.criterios.filter((c: any) => c !== event.criterio);
    this.getData(this.contractId);
  }

  transitionStatusChanged(event: any): void {
    if (
      !event ||
      !event.data ||
      !event.data.contrato ||
      !event.data.contrato.company
    ) {
      console.warn('Evento inválido:', event);
      return;
    }

    this.statusTransition = event;

    const idEntidade = event.data.contrato.company.id;
    const idProjeto = event.data.id;
    const transicaoId = event.transicaoId;
    const statusAtualId = event.data.status?.statusAtual?.id;
    const cnpj = event.data.contrato.company.cnpj;
    const transicaoNome = event.transicaoNome;
    const isAguardandoRevisao = event.data.statusAtual === 'Aguardando revisão';
    this.idProjeto = idProjeto;
    this.idEntidade = idEntidade;
    this.transicaoId = transicaoId;
    this.statusAtualId = statusAtualId;
    this.cnpj = cnpj;
    const transicaoStatusRequestData = {
      idExterno: idProjeto,
      idStatusAtual: statusAtualId,
      idTransicao: transicaoId,
      cnpj: cnpj,
    };
    const formData = new FormData();
    formData.append(
      'request',
      new Blob([JSON.stringify(transicaoStatusRequestData)], {
        type: 'application/json',
      }),
    );
    const keepId = this.activeTab === 'Executivo' ? idProjeto : undefined;
    switch (event.transicaoNome) {
      case 'Enviar para análise':
        if (isAguardandoRevisao) {
          this.openAnalyzeDialog(idProjeto, statusAtualId, transicaoId, cnpj, keepId);
        } else {
          this.transitionStatus(formData, keepId);
        }
        break;
      default:
        this.transitionStatus(formData, keepId);
        break;
    }
  }

  openAnalyzeDialog(
    idProjeto: string,
    statusAtualId: string,
    transicaoId: string,
    cnpj: string,
    keepExpandedId?: string,
  ): void {
    const dialogRef = this.dialog.open(AprovarAnaliseComponent, {
      width: '1550px',
      data: {
        idAnaliseAfericao: idProjeto,
        statusAtualId: statusAtualId,
        transicaoId: transicaoId,
        isAguardandoRevisao: false,
        fromProjetos: true,
        cnpj: cnpj,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.transitionStatus(result, keepExpandedId);
      }
    });
  }

  transitionStatus(formData?: any, keepExpandedId?: string): void {
    this.loadingService.showLoading();

    this.projetosService
      .postTransicaoStatus(formData)
      .pipe(
        take(1),
        finalize(() => this.loadingService.hideLoading()),
      )
      .subscribe({
        next: () => {
          this.getData(this.contractId, this.pageIndex, keepExpandedId);
          this.toastService.showSuccess(
            'Mudança de status realizada com sucesso',
          );
        },
        error: (erro: any) => {
          if (erro.status !== 500 && erro.status) {
            this.toastService.showError(erro.error.message);
          } else {
            this.toastService.showError();
          }
        },
      });
  }

}
